module.exports = __webpack_public_path__ + "img/bx-qapaper-publish.309ea60c.svg";